import { ReactComponent as CloseButton } from "assets/svg/outline-cross.svg";
import FullWidthImage from "components/full-width-image";
import IconButton from "components/icon-button";
import ResponsiveModal from "components/responsive-modal";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useCallback, useState } from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { fetchOrchidAPI } from "utils/api";
import getClasses from "utils/getClasses";
import { getErrorDetail } from "../utility/utils.js";
import { useLocation } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import styles from "./styles.module.scss";

const VERIFY_EMAIL_SENT = "/img/auth/verify-your-email.png";

const EmailSentModal = ({
  show,
  onHide,
  email,
}: {
  show: boolean;
  onHide: () => void;
  email?: string;
}) => {
  const { user } = useUser();
  const { pathname } = useLocation();

  const [error, setError] = useState<any>();
  const [notice, setNotice] = useState<any>();
  const [showLoader, setShowLoader] = useState(false);

  // const navigate = useNavigate();

  // const onClickContinue = async () => {
  //   const userInfo = await updateUserInfo();
  //   if (!userInfo) {
  //     navigate("/login", { replace: true });
  //     return;
  //   }
  //   const intakeFormUrl = userInfo.groups.includes("orchid_pro")
  //     ? "/quick-intake"
  //     : "/member-intake-form";
  //   if (userInfo.email_confirmed) {
  //     navigate(intakeFormUrl, { replace: true });
  //   } else {
  //     setNotice("Please confirm your email first!");
  //     setError(null);
  //   }
  // };

  // suppress on hide on some routes
  const onHideCallback = useCallback(() => {
    if (
      pathname.startsWith("/pro-dashboard") ||
      pathname.startsWith("/member-dashboard")
    ) {
      return null;
    }
    return onHide();
  }, [pathname, onHide]);

  const requestEmailResent = async () => {
    setShowLoader(true);
    const response = await fetchOrchidAPI(
      "/api/users/v1/resend_email_confirmation",
      {
        method: "PUT",
      },
    );
    if (!response.ok) {
      setError(
        `Failed to resend confimation email: ${getErrorDetail(
          await response.text(),
        )}`,
      );
      setNotice(null);
    }
    setShowLoader(false);
  };

  const { isPhonePortrait } = usePhonePortraitContext();

  return (
    <ResponsiveModal centered fullPage show={show} onHide={onHideCallback}>
      {!isPhonePortrait ? (
        <Modal.Header
          className="px-4 border-0 shadow-sm align-items-center"
          closeButton
        >
          <Modal.Title>
            {!user?.email_confirmed
              ? "Verify your account"
              : "Verify your email"}
          </Modal.Title>{" "}
        </Modal.Header>
      ) : (
        <Modal.Header className={styles["register-modal__header--phone"]}>
          <IconButton onClick={onHide}>
            <CloseButton />
          </IconButton>
          <div>Verify your email</div>
        </Modal.Header>
      )}

      <Modal.Body className="p-0">
        {isPhonePortrait && <FullWidthImage src={VERIFY_EMAIL_SENT} fluid />}
        <div className="p-3">
          <div className="text-center">
            <p className="bd-17">
              {email
                ? `We sent a verfication email to ${email}`
                : `We have sent a verfication email to you.`}
            </p>

            {!user?.email_confirmed ? (
              <p>
                In order to setup your profile, check your inbox for a
                verification email. If you didn't receive an email, please check
                your <b>junk</b> or <b>promotions</b> folder.
              </p>
            ) : (
              <p>
                Please follow the instructions in the email to continue. If you
                didn't receive the email, please check your <b>junk</b> or{" "}
                <b>promotions</b> folders.
              </p>
            )}
          </div>
          {error && <Alert variant="danger">{error.toString()}</Alert>}
          {notice && <Alert variant="info">{notice.toString()}</Alert>}
          {showLoader ? (
            <Button
              variant="primary"
              disabled
              className={getClasses(
                "w-100",
                isPhonePortrait && styles["auth-button--phone"],
              )}
            >
              Resend Email{" "}
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            </Button>
          ) : (
            <Button
              variant="primary"
              className={getClasses(
                "w-100",
                isPhonePortrait && styles["auth-button--phone"],
              )}
              onClick={requestEmailResent}
            >
              Resend email
            </Button>
          )}
          {isPhonePortrait && (
            <Button
              variant="outline-primary"
              className={getClasses("w-100 mt-3", styles["auth-button--phone"])}
              href="mailto:info@orchid.health"
            >
              Contact support
            </Button>
          )}
          {/* <p className="d-inline fs-12">Already confirmed? </p><Button variant="link" size="sm" className="fs-12 p-0" onClick={onClickContinue}>Start Enjoying Your Orchid Benefits</Button> */}
          {!isPhonePortrait && (
            <p className="mt-3">
              Need help? <a href="mailto:info@orchid.health">Contact support</a>
            </p>
          )}
        </div>
      </Modal.Body>
    </ResponsiveModal>
  );
};

export default EmailSentModal;
